require('../../fhApp/appMetaService');

"use strict";

angular.module('app.mainFrame.sidebarFooterController', [
    'app.appMetaService'
])
    .controller('app.mainFrame.sidebarFooterController', [
        '$scope', 'appMetaService',
        function ($scope, appMeta) {
            $scope.appMeta = appMeta;
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/sidebar/sidebarFooterController.js